module.exports = __webpack_public_path__ + "img/feature-illustration-2.0137fde.svg";